import script from "./DashboardTrend.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardTrend.vue?vue&type=script&setup=true&lang=js"

import "./DashboardTrend.vue?vue&type=style&index=0&id=b84572a6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b84572a6"]])

export default __exports__